import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import type { EventId } from '@ps/isp-web-services-types';
import classNames from 'clsx';
import React from 'react';

import EventStatus from '@swf/sports/components/EventStatus/EventStatus';
import useParticipants from '@swf/sports/hooks/useParticipants';
import type { EventTypeId } from '@swf/sports/types/eventType';

import BackgroundImage from '../BackgroundImage/BackgroundImage';

import styles from './Loading.scss';

interface Props {
  eventId: EventId;
  eventTime: string;
  eventTypeId: EventTypeId;
  inPlay: boolean;
  name: string;
}

const Loading: React.FC<Props> = ({ eventId, name, eventTypeId, eventTime, inPlay }) => {
  const [teamAName, teamBName] = useParticipants(name)?.map(({ participant }) => participant) ?? [];

  return (
    <BackgroundImage eventTypeId={eventTypeId}>
      <div className={styles.wrapper}>
        <div className={styles.status}>
          <EventStatus
            eventTypeId={eventTypeId}
            inPlay={inPlay}
            canTurnInPlay
            startTime={eventTime}
            eventId={eventId}
            size="XSmall"
          />
        </div>
        <div className={classNames(styles.team, styles.teamA)}>{teamAName}</div>
        <div className={classNames(styles.score, styles.teamAScore)}>
          <Skeleton variant="rect" height="32px" width="24px" animation="pulse" />
        </div>
        <div className={classNames(styles.team, styles.teamB)}>{teamBName} </div>
        <div className={classNames(styles.score, styles.teamBScore)}>
          <Skeleton variant="rect" height="32px" width="24px" animation="pulse" />
        </div>
      </div>
    </BackgroundImage>
  );
};

export default Loading;
